export type ApiToolPreviewPayload = {
  success?: boolean;
  statusCode?: number;
  error?: string | null;
  body?: unknown;
};

export type ApiToolPreviewAuthWarning = {
  statusCode: number;
  messageKey:
    | 'authPreviewWarningBearer'
    | 'authPreviewWarningBasic'
    | 'authPreviewWarningApiKey'
    | 'authPreviewWarningGeneric'
    | 'authPreviewWarningNoAuthConfigured';
};

const AUTH_RELATED_STATUS_CODES = new Set([401, 403]);

export function parseApiToolPreviewResult(raw: string): ApiToolPreviewPayload | null {
  try {
    const parsed = JSON.parse(raw) as ApiToolPreviewPayload;
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function getAuthPreviewWarning(
  preview: ApiToolPreviewPayload | null,
  authType: string,
  authConfigured = false,
): ApiToolPreviewAuthWarning | null {
  if (!preview || preview.success !== false || typeof preview.statusCode !== 'number') {
    return null;
  }

  const statusCode = preview.statusCode;
  if (!AUTH_RELATED_STATUS_CODES.has(statusCode)) {
    return null;
  }

  if (authType === 'none' || !authConfigured) {
    return {
      statusCode,
      messageKey: 'authPreviewWarningNoAuthConfigured',
    };
  }

  const messageKey = (() => {
    switch (authType) {
      case 'bearer':
        return 'authPreviewWarningBearer' as const;
      case 'basic':
        return 'authPreviewWarningBasic' as const;
      case 'apiKey':
        return 'authPreviewWarningApiKey' as const;
      default:
        return 'authPreviewWarningGeneric' as const;
    }
  })();

  return { statusCode, messageKey };
}
